import React from 'react';
import { InvoiceStatus, statusStyles } from '../invoicesTypes';
import styles from './InvoiceStatusBadge.module.css';

interface InvoiceStatusBadgeProps {
  status: InvoiceStatus;
}

export const InvoiceStatusBadge: React.FC<InvoiceStatusBadgeProps> = ({ status }) => {
  const s = statusStyles[status];
  return (
    <span
      className={styles.badge}
      style={{ background: s.bg, color: s.color, borderColor: s.border }}
    >
      {status}
    </span>
  );
};
